import { useLocation } from "react-router-dom";

// A custom hook that builds on useLocation to parse
// the query string for you.
// Source: https://reactrouter.com/web/example/query-parameters
export const useQueryParams = () => {
  return new URLSearchParams(useLocation().search);
};
